import { render, staticRenderFns } from "./QuotaApply.vue?vue&type=template&id=2585a4cc&scoped=true&"
import script from "./QuotaApply.vue?vue&type=script&lang=js&"
export * from "./QuotaApply.vue?vue&type=script&lang=js&"
import style0 from "./QuotaApply.vue?vue&type=style&index=0&id=2585a4cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585a4cc",
  null
  
)

export default component.exports